import { render, staticRenderFns } from "./DiffCell.vue?vue&type=template&id=47e7313e&scoped=true&"
import script from "./DiffCell.vue?vue&type=script&lang=js&"
export * from "./DiffCell.vue?vue&type=script&lang=js&"
import style0 from "./DiffCell.vue?vue&type=style&index=0&id=47e7313e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e7313e",
  null
  
)

export default component.exports